module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門4_3.bc7c7a86.png";